import styled from 'styled-components';
import theme from 'styled-theming';
import colors from '../../../theme/Colors';

const spinnerColor = theme('brand', {
    brenntag: colors.brenntag.primary, 
    bcd: colors.bcd.primary
});

interface SpinnerProps {
    color: string;
}

export const SSpinner = styled.span<SpinnerProps>`
    
    @keyframes rotating {
        from {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    svg {
        fill: ${props => props.color ? props.color : spinnerColor};
        -webkit-animation: rotating 1s linear infinite;
        -moz-animation: rotating 1s linear infinite;
        -ms-animation: rotating 1s linear infinite;
        -o-animation: rotating 1s linear infinite;
        animation: rotating 1s linear infinite;
    }
`;